package us.laantech.laanmanage.feature.store.inventory

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import io.ktor.client.call.body
import io.ktor.client.request.get
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch
import us.laantech.common.dto.RetailProductDTO
import us.laantech.common.api.KtorClient


data class InventoryManagementUiState(
    val selectedStore: String = "Test Com 01",
    val searchQuery: String = "",
    val products: List<RetailProductDTO> = listOf(),

    val showInventoryHistoryModal: Boolean = false,
    val selectedProduct: RetailProductDTO? = null,
)


class InventoryManagementViewModel: ViewModel() {

    private val _uiState = MutableStateFlow(InventoryManagementUiState())
    val uiState = _uiState.asStateFlow()
    private val ktClient = KtorClient.instance.client
    private val scope = CoroutineScope(Dispatchers.Default)

    fun loadProducts() {
        scope.launch {
            val response = ktClient.get("/backoffice/store-management/products/list")

            val products = response.body<List<RetailProductDTO>>()

            _uiState.update { it.copy(products = products) }
        }
    }

    fun toggleInventoryHistoryModal(product: RetailProductDTO?) {
        _uiState.update { it.copy(
            showInventoryHistoryModal = !it.showInventoryHistoryModal,
            selectedProduct = product)
        }
    }

//    fun openInventoryHistoryModal(product: RetailProductDTO) {
//        _uiState.update { it.copy(
//            showInventoryHistoryModal = true,
//            selectedProduct = product)
//        }
//    }
//
//    fun closeInventoryHistoryModal() {
//        _uiState.update { it.copy(
//            showInventoryHistoryModal = false,
//            selectedProduct = null)
//        }
//    }



}
